import React, { Component } from "react";
import { NumericFormat } from "react-number-format";
import { Form } from "react-bootstrap";
let isMobile = window.innerWidth < 700;
class Allques extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quesList: this.props.quesList,
    };
  }

  componentDidUpdate() {
    if (this.state.quesList !== this.props.quesList) {
      this.setState({ quesList: this.props.quesList });
    }
  }

  createTable = () => {
    const { quesList } = this.state;
    const { updateQuesList } = this.props;
    let table = [];

    // Outer loop to create parent
    for (let i = 0; i < quesList.length; i++) {
      if (quesList[i].response === false) {
        quesList[i].remarks = "";
      }
      table.push(
        <tr  className={"bringcolumn " + (i % 2 === 1 ? "odd-row" : "")} key={i}>
          <td className={"responsivecolumn" + "tableQues" + " " + `trow${i}`}>
            {quesList[i].ques}
          </td>
 
          <td className="tableAns">
            <div className="row">
              {/* <div className="col-6 col-md-6 col-sm-6 col-lg-6">
            <Form.Check
              inline
              id={`inputY-${i}`}
              value="Y"
              name={quesList[i].name}
              checked={quesList[i].response}
              label="Yes"
              type="radio"
              onChange={(e) => updateQuesList(e, "response", true)}
            />

              </div>
              <div className="col-6 col-md-6 col-sm-6 col-lg-6">
            <Form.Check
              inline
              id={`inputN-${i}`}
              value="N"
              name={quesList[i].name}
              checked={!quesList[i].response}
              label="No"
              type="radio"
              onChange={(e) => updateQuesList(e, "response", false)}
            />
              </div> */}
               <div className="form-check d-flex justify-content-center align-items-center  col-6 col-md-6 col-sm-6 col-lg-6">
                
                <input
                type="radio"
                id={`inputY-${i}`}
                name={quesList[i].name}
                value="Y"
                checked={quesList[i].response}
                onChange={(e) => updateQuesList(e, "response", true)}
                className="mx-1"
              />
              <label htmlFor={`inputY-${i}`} className="fw-normal">Yes</label>
   
              </div>

                <div className="form-check d-flex justify-content-center align-items-center  col-6 col-md-6 col-sm-6 col-lg-6">
                <input
                  type="radio"
                  id={`inputN-${i}`}
                  name={quesList[i].name}
                  value="N"
                  checked={!quesList[i].response}
                  onChange={(e) => updateQuesList(e, "response", false)}
                  className="mx-1"
                />
                <label htmlFor={`inputN-${i}`} className="fw-normal">No</label>
                </div>

            </div>
          </td>
          <td className="tableRemarks">
            {quesList[i].type === "percent" || quesList[i].name === "q6" ? (
              <NumericFormat
                id={"qr" + (i + 1)}
                className={
                  !quesList[i].response ? "hidden ques-input" : "ques-input"
                }
                maxLength="3"
                suffix={"%"}
                value={quesList[i].response === true ? quesList[i].remarks : ""}
              />
            ) : (
              <input
                id={`remarks-${i}`}
                value={
                  quesList[i].remarks && quesList[i].remarks !== "none"
                    ? quesList[i].remarks
                    : ""
                }
                type="text"
                className={
                  !quesList[i].response ? "hidden ques-input" : "ques-input"
                }
                disabled={!quesList[i].response}
                onChange={(e) => updateQuesList(e, "remarks", e.target.value)}
              />
            )}
          </td>
        </tr>
      );
    }
    return table;
  };
  componentDidMount() {
    const { setUWQues } = this.props;
    let obj = JSON.parse(sessionStorage.getItem("currProspect"));
    if (obj) {
      if (obj.uwQues) {
        setUWQues(obj.uwQues);
      }
    }
  }
  render() {
    return (
      <table className="table table-borderless table-undrques">
        <thead>
          {!isMobile ? (
            <tr>
              <th className="tableQues">Questions</th>
              <th className="tableAns">Response</th>
              <th className="tableRem">Remarks</th>
            </tr>
          ) : (
            " "
          )}
        </thead>
        <tbody>{this.createTable()}</tbody>
      </table>
    );
  }
}
export default Allques;
